module.exports = __webpack_public_path__ + "img/emoji-audacieux@2x.c9d0860c.png";